export enum OwnerEnum {
  USER = 'USER',
  TEAM = 'TEAM'
}
